const encodeUnsafeCharacters = (str) => {
  return String(str).replace(/[:;]/g, (match) => {
    return `%${match.charCodeAt(0).toString(16).toUpperCase()}`;
  });
};

export default encodeUnsafeCharacters;
